import _ from 'lodash';

const ResizableField = (elem, handlerWidthChange, finishWidthChange, handlerHeightChange, finishHeightChange) => {
  // The height handlers are optional: a field that is only meant to be resized
  // horizontally (Submitters info auto entry, whose height follows its content)
  // passes neither, and gets no row-resize handle to grab by mistake.
  const canResizeHeight = typeof handlerHeightChange === 'function' && typeof finishHeightChange === 'function';

  if (canResizeHeight && !elem.parentElement.querySelector('.resize-height-div')) {
    let resizeHeightDiv = createResizeHeightDiv();
    elem.insertAdjacentElement('afterend', resizeHeightDiv);
    addResizeHeightEvents(resizeHeightDiv);
  }

  if (!elem.parentElement.querySelector('.resize-width-div')) {
    let resizeWidthDiv = createResizeWidthDiv();
    elem.insertAdjacentElement('afterend', resizeWidthDiv);
    addResizeWidthEvents(resizeWidthDiv);
  }

  function addResizeWidthEvents(resizeWidthDiv) {
    let cursorX;
    let inputWrapperElem;
    let widthShift;

    resizeWidthDiv.addEventListener('mousedown', function (e) {
      e.preventDefault();
      (inputWrapperElem = e.target.closest('.form-builder-element-preview')), (cursorX = e.pageX);
      let d = (function (e) {
        if ('border-box' === l(e, 'box-sizing')) return 0;
        let cursorX = l(e, 'padding-left'),
          inputWrapperElem = l(e, 'padding-right');
        return parseInt(cursorX) + parseInt(inputWrapperElem);
      })(inputWrapperElem);
      widthShift = inputWrapperElem.offsetWidth - d;
    });

    resizeWidthDiv.addEventListener('mouseover', function (e) {
      if (e.target.parentElement) {
        e.target.style.borderRight = '2px solid #CBD2E0';
      }
    });

    resizeWidthDiv.addEventListener('mouseout', function (e) {
      e.target.style.borderRight = '';
    });

    document.addEventListener('mousemove', function (e) {
      if (inputWrapperElem) {
        let d = e.pageX - cursorX;
        handlerWidthChange(d);
      }
    });

    document.addEventListener('mouseup', function (e) {
      if (inputWrapperElem) {
        let d = e.pageX - cursorX;
        finishWidthChange(d);
      }
      (inputWrapperElem = void 0), (cursorX = void 0), (widthShift = void 0);
    });
  }

  function addResizeHeightEvents(resizeHeightDiv) {
    let cursorY;
    let inputWrapperElem;
    let heightShift;

    resizeHeightDiv.addEventListener('mouseover', function (e) {
      if (e.target.parentElement) {
        e.target.style.borderBottom = '2px solid #CBD2E0';
      }
    });

    resizeHeightDiv.addEventListener('mouseout', function (e) {
      e.target.style.borderBottom = '';
    });

    resizeHeightDiv.addEventListener('mousedown', function (e) {
      e.preventDefault();
      (inputWrapperElem = e.target.parentElement), (cursorY = e.pageY);
      let d = (function (e) {
        if ('border-box' === l(e, 'box-sizing')) return 0;
        let cursorY = l(e, 'padding-top'),
          inputWrapperElem = l(e, 'padding-top');
        return parseInt(cursorY) + parseInt(inputWrapperElem);
      })(inputWrapperElem);
      heightShift = inputWrapperElem.offsetHeight - d;
    });

    document.addEventListener('mousemove', function (e) {
      if (inputWrapperElem) {
        let d = e.pageY - cursorY;
        handlerHeightChange(d);
      }
    });

    // Only a drag this handle started ends here, not every mouseup on the page.
    // The height is taken from where the pointer is let go of, in the same
    // update as the drag's end: React handles the moves before it as less
    // urgent, so after a quick drag some of them are still waiting when the
    // button comes up, and ending on the height last drawn saved a height the
    // pointer had already left - with the right one saved straight after it.
    document.addEventListener('mouseup', function (e) {
      if (inputWrapperElem) {
        handlerHeightChange(e.pageY - cursorY);
        finishHeightChange();
      }
      (inputWrapperElem = void 0), (cursorY = void 0), (heightShift = void 0);
    });
  }

  function createResizeWidthDiv() {
    let resizeDivElem = document.createElement('div');
    resizeDivElem.className = 'resize-width-div';

    return (
      (resizeDivElem.style.width = '5px'),
      (resizeDivElem.style.display = 'inline-block'),
      (resizeDivElem.style.cursor = 'col-resize'),
      (resizeDivElem.style.userSelect = 'none'),
      (resizeDivElem.style.height = '100%'),
      (resizeDivElem.style.marginLeft = '-5px'),
      (resizeDivElem.style.zIndex = 999),
      resizeDivElem
    );
  }

  function createResizeHeightDiv() {
    let resizeDivElem = document.createElement('div');
    resizeDivElem.className = 'resize-height-div';

    return (
      (resizeDivElem.style.width = '100%'),
      (resizeDivElem.style.display = 'block'),
      (resizeDivElem.style.cursor = 'row-resize'),
      (resizeDivElem.style.userSelect = 'none'),
      (resizeDivElem.style.height = '5px'),
      (resizeDivElem.style.marginTop = '-5px'),
      (resizeDivElem.style.zIndex = 999),
      resizeDivElem
    );
  }

  function l(e, t) {
    return window.getComputedStyle(e, null).getPropertyValue(t);
  }
};

export default ResizableField;
